
// 详情基本信息
export const detailBaseInfoOption = function() {
  return [
    {
      prop: 'beginTime',
      label: '统筹起期',
    },
    {
      prop: 'endTime',
      label: '统筹止期',
    },
    {
      prop: 'days',
      label: '统筹天数',
    },
    {
      prop: 'orgName',
      label: '出单公司',
    },
    {
      prop: 'saleName',
      label: '业务员',
    },
    {
      prop: 'payType',
      label: '缴费方式',
    },
    {
      prop: 'handlerName',
      label: '经办人',
    },
    {
      prop: 'creatorName',
      label: '制单人',
    },
    {
      prop: 'remark',
      label: '备注'
    }
  ]
}

// 详情车辆信息
export const detailCarInfoOption = function() {
  return [
    {
      prop: 'carNo',
      label: '车牌号',
    },
    {
      prop: 'engineNo',
      label: '发动机号',
    },
    {
      prop: 'vin',
      label: '车架号',
    },
    {
      prop: 'beginDate',
      label: '初登日期',
    },
    // {
    //   prop: 'usetype',
    //   label: '使用性质',
    // },
	{
	  prop: 'usetype',
	  label: '营运性质',
	},
    {
      prop: 'brandType',
      label: '品牌型号',
    },
    {
      prop: 'passengerCount',
      label: '核定载客',
    },
    {
      prop: 'loadWeight',
      label: '核定载质量',
    },
    {
      prop: 'carType',
      label: '车型',
    },
    {
      prop: 'newPrice',
      label: '新车价',
    },
    {
      prop: 'userYears',
      label: '使用年数',
    },
    // {
    //   prop: 'accidentType',
    //   label: '历年状态',
    // },
    {
      prop: 'nowPrice',
      label: '实际参考价',
    },
    {
      prop: 'notice',
      label: '验车提示',
    },
    {
      prop: 'goArea',
      label: '行驶区域',
    },
    {
      prop: 'insYears',
      label: '参统年数',
    },
    {
      prop: 'accidentCount',
      label: '参统期补偿次数',
    },
	{
	  prop: 'originalBill',
	  label: '原始统筹',
	},
	{
	  prop: 'originalRebate',
	  label: '原始折扣',
	},
	{
	  prop: 'carBigType',
	  label: '车辆大类',
	},
	{
	  prop: 'carVehicles',
	  label: '车辆种类',
	},
  ]
}

// 详情关系人信息
export const detailPersonInfoOption = function() {
  return [
    {
      prop: 'isgroup',
      label: '人员类型',
    },
    {
      prop: 'personName',
      label: '名称',
    },
    {
      prop: 'certNo',
      label: '证件号',
    },
    {
      prop: 'tel',
      label: '电话',
    },
    {
      prop: 'addr',
      label: '地址',
    },
    {
      prop: 'email',
      label: '邮箱',
    },
  ]
}

export default {}